import styles from "@/styles/global/product-item.module.scss";
import MyTags from "@/components/global/MyTags";
import Image from "next/image";
import { Rate } from 'react-vant';
import type { ProductType } from '@/types/product';
import { gaItemFromProduct, gaSelectItem } from "@/utils/gaEvent";

interface ProductItemProps {
  product: ProductType;
  isClearance?: boolean;
  showAfterpaybenifit?: boolean
  itemListId?: string;
  itemListName?: string;
  itemIndex?: number;
}

export default function ProductItem({
  product,
  isClearance,
  showAfterpaybenifit,
  itemListId,
  itemListName,
  itemIndex,
}: ProductItemProps) {
  const priceArr = Number(product.price).toFixed(2).split('.')

  const handleViewDetail = () => {
    const trackedListId = itemListId || String(product.location || "product_list");
    const trackedListName = itemListName || String(product.location || "Product list");
    gaSelectItem({
      item_list_id: trackedListId,
      item_list_name: trackedListName,
      items: [
        gaItemFromProduct(product, {
          index:
            itemIndex ??
            (product.position !== undefined
              ? Number(product.position)
              : undefined),
          itemListId: trackedListId,
          itemListName: trackedListName,
        }),
      ],
    });
    window.location.href = product.url
  };

  return (
    <div className={styles["comp-product-item"]} onClick={() => handleViewDetail()}>
      <Image
        className={styles["product-image"]}
        src={
          product.filename || ''
        }
        alt={product.name}
        width={155}
        height={155}
      />
      
      <div className={styles["product-tags-box"]}>
        {
          !!(product.inStock) && (
            <MyTags {...{ ...product, isSingle: true, position: isClearance ? 'clearance' : undefined }}></MyTags>
          )
        }
      </div>

      <div className={styles["product-name"]}>
        {
          product.inStock ? null : (
            <span className={styles["out-of-stock"]}>(OUT OF STOCK)&nbsp;</span>
          )
        }
        {product.name}
      </div>

      <div className={styles["price-desc"]}>
        <div className={styles["price"]}>
          <span>
            ${priceArr[0]}.<i>{priceArr[1]}</i>
          </span>
        </div>
        {
          !!(product.normalPrice && product.normalPrice != product.price) && (
            <div className={styles["marking-price"]}>
              <span>${Number(product.normalPrice).toFixed(2)}</span>
            </div>
          )
        }
      </div>

      {
        showAfterpaybenifit ? (
          <div className={styles["afterpay-benefit"]}>
            or 4 payments
            <br />
            <div className={styles['per-price']}>
              of {(product.price / 4).toFixed(2)} with
              <Image
                alt={"afterpay logo"}
                width={76}
                height={17}
                src={`${process.env.IMAGE_DOMAIN}/product-detail/icon-afterpay.png`}
              ></Image>
            </div>
          </div>
        ) : null
      }

      {/* 有评论数才展示评分 */}
      <div className={styles["review-box"]}>
        {
          product.review && product.review.total ? (
            <>
              <Rate
                value={product.review.avgRank}
                voidColor={"#dedede"}
                allowHalf
                readOnly
              />
              <div className={styles["review-count"]}>({product.review.total})</div>
            </>
          ) : null
        }
      </div>

      {
        !Array.isArray(product.promotion) && product.promotion.promotionRate ? (
          <div 
            className={styles['promotion-rate-box']}
            style={{ 
              background: `url('${process.env.IMAGE_DOMAIN}/home/csotd-promotion-bg.svg') no-repeat`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              }}
          >
            <div className={styles['promotion-rate-number']}>
              {product.promotion.promotionRate}%
            </div>
            <div className={styles['promotion-rate-text']}>OFF</div>
          </div>
        ) : null
      }
    </div>
  );
}
